<template>
  <div class="language-switcher">
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn aria-label="Language Switcher Button" icon="mdi mdi-google-translate" variant="text" v-bind="props"></v-btn>
        </template>
        <v-list>
          <v-list-item @click="changeLanguage('pl')">
            <v-list-item-title>PL</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeLanguage('en')">
            <v-list-item-title>EN</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeLanguage('de')">
            <v-list-item-title>DE</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import store from '@/store';
import { useLocale } from "vuetify";

const LanguageSwitcher: object = defineComponent({
  props: {

  },
  setup() {
    const locale = useLocale();
    // const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    // const handleContrastClick = () => store.commit('flipContrastActive');

    const changeLanguage = (langKey: string) => {
      switch (langKey) {
        case 'pl':
          store.commit('flipLanguage', 0);
          locale.current.value = 'pl';
          break;
        case 'en':
          store.commit('flipLanguage', 1);
          locale.current.value = 'en';
          break;
        case 'de':
          store.commit('flipLanguage', 2);
          locale.current.value = 'de';
          break;
        default:
          store.commit('flipLanguage', 0);
          locale.current.value = 'pl';
          break;
      }
    };

    return {
      changeLanguage,
      // getContrastActive,
      // handleContrastClick,
    };
  },
});
export default LanguageSwitcher;
</script>


<style scoped lang="scss">


</style>
